import { createStyles, HawkinsGlobalClass, makeStyles } from '@hawkins/styles';
import { fontSizes, sizings } from '@hawkins/variables';
export var avatarSizes = ['compact', 'small', 'regular', 'medium', 'large'];
export var avatarPartSizes = {
    compact: {
        fontSize: fontSizes.fontSize0,
        diameter: sizings.size2,
        diameterPx: 24,
        offset: -8,
        textLoaderHeight: 20,
    },
    small: {
        fontSize: fontSizes.fontSize0,
        diameter: sizings.size3,
        diameterPx: 32,
        offset: -10,
        textLoaderHeight: 20,
    },
    regular: {
        fontSize: fontSizes.fontSize4,
        diameter: sizings.size5,
        diameterPx: 48,
        offset: -13,
        textLoaderHeight: 20,
    },
    medium: {
        fontSize: fontSizes.fontSize7,
        diameter: '80px',
        diameterPx: 80,
        offset: -20,
        textLoaderHeight: 30,
    },
    large: {
        fontSize: fontSizes.fontSize9,
        diameter: sizings.size7,
        diameterPx: 112,
        offset: -28,
        textLoaderHeight: 40,
    },
};
export function avatarStyles(theme) {
    var _a, _b;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the caret icon when the component is a <Menu> trigger. */
        caret: {
            color: hawkins.icon.fillRegular,
            marginLeft: hawkinsVariables.spacings.space0,
        },
        /** Class name of the root element. */
        root: (_a = {
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
                margin: 0,
                position: 'relative'
            },
            _a["&.".concat(HawkinsGlobalClass.FOCUSABLE)] = (_b = {},
                _b[hawkinsUtils.getFocusRingedElementSelector('&', '::after')] = hawkinsUtils.getFocusRingPosition(2),
                _b),
            _a),
        /** Class name of the root element when the component has a click handler. */
        rootClickable: {
            cursor: 'pointer',
        },
        /** Class name applied to the circle element in the component */
        circle: {
            alignItems: 'center',
            display: 'flex',
            flexShrink: 0,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
            justifyContent: 'center',
        },
        /** Class name applied when variant = 'chip' */
        chip: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            fontSize: fontSizes.fontSize0,
            height: sizings.size2,
            width: sizings.size2,
        },
        /** @private */
        compactChip: {
            fontSize: 8,
            height: sizings.size1,
            width: sizings.size1,
        },
        /** @private */
        compact: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius2,
            fontSize: avatarPartSizes.compact.fontSize,
            height: avatarPartSizes.compact.diameter,
            width: avatarPartSizes.compact.diameter,
        },
        /** @private */
        small: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius2,
            fontSize: avatarPartSizes.small.fontSize,
            height: avatarPartSizes.small.diameter,
            width: avatarPartSizes.small.diameter,
        },
        /** @private */
        regular: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius2,
            fontSize: avatarPartSizes.regular.fontSize,
            height: avatarPartSizes.regular.diameter,
            width: avatarPartSizes.regular.diameter,
        },
        /** @private */
        medium: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius2,
            fontSize: avatarPartSizes.medium.fontSize,
            height: avatarPartSizes.medium.diameter,
            width: avatarPartSizes.medium.diameter,
        },
        /** @private */
        large: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius2,
            fontSize: avatarPartSizes.large.fontSize,
            height: avatarPartSizes.large.diameter,
            width: avatarPartSizes.large.diameter,
        },
        /** Class name applied to the image element in the component */
        image: {
            objectFit: 'cover',
        },
        /** Class name applied when the component has no src and the default colors */
        default: {
            background: hawkins.ui.backgroundColor5,
            color: hawkins.persistent.textColorWhiteRegular,
        },
        /** Class name applied to the text container, where name, title, etc live */
        textContainer: {
            maxWidth: '100%',
        },
        /** @private */
        compactTextContainer: {
            marginLeft: hawkinsVariables.spacings.space0,
        },
        /** @private */
        smallTextContainer: {
            marginLeft: hawkinsVariables.spacings.space1,
        },
        /** @private */
        regularTextContainer: {
            marginLeft: hawkinsVariables.spacings.space2,
        },
        /** @private */
        mediumTextContainer: {
            marginLeft: hawkinsVariables.spacings.space2,
        },
        /** @private */
        largeTextContainer: {
            marginLeft: hawkinsVariables.spacings.space4,
        },
        /** Class name applied to the name div */
        name: {
            color: hawkins.textColor.textColorRegular,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
        },
        /** @private */
        compactName: {
            fontSize: fontSizes.fontSize0,
        },
        /** @private */
        smallName: {
            fontSize: fontSizes.fontSize2,
        },
        /** @private */
        regularName: {
            fontSize: fontSizes.fontSize2,
        },
        /** @private */
        mediumName: {
            fontSize: fontSizes.fontSize7,
        },
        /** @private */
        largeName: {
            fontSize: fontSizes.fontSize10,
        },
        /** Class name applied to the prefix and postfix labels above/below the name */
        label: {
            color: hawkins.textColor.textColorXlight,
            fontWeight: hawkinsVariables.fontWeights.fontWeight0,
        },
        /** @private */
        compactPrefixLabel: {
            fontSize: fontSizes.fontSize0,
        },
        /** @private */
        smallPrefixLabel: {
            fontSize: fontSizes.fontSize2,
        },
        /** @private */
        smallPostfixLabel: {
            fontSize: fontSizes.fontSize2,
        },
        /** @private */
        compactPostfixLabel: {
            fontSize: fontSizes.fontSize0,
        },
        /** @private */
        regularPrefixLabel: {
            fontSize: fontSizes.fontSize2,
        },
        /** @private */
        regularPostfixLabel: {
            fontSize: fontSizes.fontSize2,
        },
        /** @private */
        mediumPrefixLabel: {
            fontSize: fontSizes.fontSize3,
        },
        /** @private */
        mediumPostfixLabel: {
            fontSize: fontSizes.fontSize3,
        },
        /** @private */
        largePrefixLabel: {
            fontSize: fontSizes.fontSize1,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
            textTransform: 'uppercase',
        },
        /** @private */
        largePostfixLabel: {
            fontSize: fontSizes.fontSize4,
        },
        /** Class name applied to the `endAdornment` section of the component */
        endAdornment: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
        },
    });
}
export var useAvatarStyles = makeStyles(avatarStyles, { name: 'Hawkins-Avatar' });
